export type StrBool = 'true' | 'false';
export type UserRole = 'admin' | 'student' | 'editor';
export type WPUser = {
	user: {
		data: {
			ID: string;
			user_login: string;
			user_pass: string;
			user_nicename: string;
			user_email: string;
			user_url: string;
			user_registered: string;
			user_activation_key: string;
			user_status: string;
			display_name: string;
		};
		ID: 1;
		caps: { [key: string]: boolean };
		cap_key: string;
		roles: string[];
		allcaps: {
			switch_themes: boolean;
			edit_themes: boolean;
			activate_plugins: boolean;
			edit_plugins: boolean;
			edit_users: boolean;
			edit_files: boolean;
			manage_options: boolean;
			moderate_comments: boolean;
			manage_categories: boolean;
			manage_links: boolean;
			upload_files: boolean;
			import: boolean;
			unfiltered_html: boolean;
			edit_posts: boolean;
			edit_others_posts: boolean;
			edit_published_posts: boolean;
			publish_posts: boolean;
			edit_pages: boolean;
			read: boolean;
			level_10: boolean;
			level_9: boolean;
			level_8: boolean;
			level_7: boolean;
			level_6: boolean;
			level_5: boolean;
			level_4: boolean;
			level_3: boolean;
			level_2: boolean;
			level_1: boolean;
			level_0: boolean;
			edit_others_pages: boolean;
			edit_published_pages: boolean;
			publish_pages: boolean;
			delete_pages: boolean;
			delete_others_pages: boolean;
			delete_published_pages: boolean;
			delete_posts: boolean;
			delete_others_posts: boolean;
			delete_published_posts: boolean;
			delete_private_posts: boolean;
			edit_private_posts: boolean;
			read_private_posts: boolean;
			delete_private_pages: boolean;
			edit_private_pages: boolean;
			read_private_pages: boolean;
			delete_users: boolean;
			create_users: boolean;
			unfiltered_upload: boolean;
			edit_dashboard: boolean;
			update_plugins: boolean;
			delete_plugins: boolean;
			install_plugins: boolean;
			update_themes: boolean;
			install_themes: boolean;
			update_core: boolean;
			list_users: boolean;
			remove_users: boolean;
			promote_users: boolean;
			edit_theme_options: boolean;
			delete_themes: boolean;
			export: boolean;
			administrator: boolean;
		};
		filter: any;
	};
	usermeta: {
		nickname: [string];
		first_name: [string];
		last_name: [string];
		description: [string];
		rich_editing: StrBool[];
		syntax_highlighting: StrBool[];
		comment_shortcuts: StrBool[];
		admin_color: [string];
		use_ssl: [string];
		show_admin_bar_front: StrBool[];
		locale: [string];
		wp_capabilities: [string];
		wp_user_level: [string];
		dismissed_wp_pointers: [string];
		show_welcome_panel: [string];
		session_tokens: [string];
		wp_dashboard_quick_press_last_post_id: [string];
		'community-events-location': [string];
	};
};

export type AppUser = {
	id: number;
	name: string;
	lastName: string;
	role: UserRole;
};

export type Product = {
	id: string;
	name: string;
	ic: string;
};
export type SelectTimes = {
	minutes: string;
	seconds: string;
};

export type SelectCat = {
	subcategories: {
		id: number;
		name: string;
		isChoosen: boolean;
		isDisabled: boolean;
		subjects: string;
	}[];
	id: number;
	name: string;
	isChoosen: boolean;
	isDisabled: boolean;
	times: {
		min: SelectTimes;
		max: SelectTimes;
		def: SelectTimes;
		current: SelectTimes;
	};
	lvl: {
		max_value: number;
		max_value_700: number;
	};
	subjects: string;
};
export type SelectDomain = {
	name: string;
	categories: SelectCat[];
};
export type ProductWithDomains = {
	domMultyselect: boolean;
	catMultyselect: boolean;
	subcatMultyselect: boolean;
	id: number;
	name: string;
	url?: string;
	ic?: string;
	is_purchased: boolean;
	domains: SelectDomain[];
};

export type QuestionType = 'single' | 'bundle';
export type DBBoolean = 1 | null;
export type Level = {
	// id: number;
	max_value: number;
	max_value_700: number;
	rate_up: number;
	rate_down: number;
	rate_up_700: number;
	rate_down_700: number;
	// category_id: number;
};
export type Subject = {
	id: number;
	name: string;
	subcategory_id?: number;
	category_id: number;
	domain_id: number;
};
export type Subcategory = {
	id: number;
	name: string;
	category_id: number;
	domain_id: number;
	subjects?: Subject[];
};
export type Category = {
	id: number;
	name: string;
	domain_id: number;
	level: Level;
	subcategories?: Subcategory[];
	subjects?: Subject[];
};
export type TymerValues = { minutes: string; seconds: string };
export type Domain = {
	id: number;
	name: string;
	categories: Category[];
};
export type Bundle = {
	id: number;
	makat: string | null;
	content: string;
	level: number | null;
	level_700: number | null;
	is_demo: DBBoolean;
	is_700: DBBoolean;
	// is_published: DBBoolean;
	domain_id: number;
	category_id: number;
	subcategory_id: number | null;
	subject_id: number | null;
};
export type BundleWithQuestions = Bundle & { questions: Question[] };
export type AnswerArr = [Answer, Answer, Answer, Answer];
export type AnsLayout = '1x4' | '2x2' | '4x1';
export type Question = {
	id: number;
	makat: string | null;
	content: string;
	solution: string;
	answers: AnswerArr;
	level: number | null;
	level_700: number | null;
	is_demo: DBBoolean;
	is_700: DBBoolean;
	// is_published: DBBoolean;
	ans_layout: AnsLayout;
	domain_id: number;
	category_id: number;
	subcategory_id: number | null;
	subject_id: number | null;
	bundle_id: number | null;
	index_in_bundle: number | null;
};
export type AnswerID = 1 | 2 | 3 | 4;
export type DBBooleanStr = '1' | null;
export type Answer = {
	id: AnswerID;
	content: string;
	is_right: DBBoolean;
	question_id: number;
};

export type AnswerStrArr = [AnswerStr, AnswerStr, AnswerStr, AnswerStr];

export type AnswerIDStr = '1' | '2' | '3' | '4';
export type AnswerStr = {
	id: AnswerIDStr;
	content: string;
	is_right: DBBooleanStr;
	question_id: string;
};

export type BundleStr = {
	id: string;
	makat: string | null;
	content: string;
	level: string | null;
	level_700: string | null;
	is_demo: '1' | null;
	is_700: '1' | null;
	// is_published: DBBoolean;
	domain_id: string;
	category_id: string;
	subcategory_id: string | null;
	subject_id: string | null;
};
export type AnswerArrStr = [AnswerStr, AnswerStr, AnswerStr, AnswerStr];
export type QuestionStr = {
	id: string;
	makat: string | null;
	content: string;
	solution: string;
	answers: AnswerStrArr;
	level: string | null;
	level_700: string | null;
	is_demo: '1' | null;
	is_700: '1' | null;
	ans_layout: AnsLayout;
	domain_id: string;
	category_id: string;
	subcategory_id: string | null;
	subject_id: string | null;
	bundle_id: string | null;
	index_in_bundle: string | null;

	posts_id: string;
	status?: 0 | 1 | 2; // wrong, right, timeout
	exersizeTime?: string;
	selected_ans_id?: AnswerID;
};

export type QuizCat = {
	catData: {
		id: string;
		name: string;
		domain_id: string;
		is_700: 1 | 0;
		is_demo: 1 | 0;
		times: {
			min: string;
			max: string;
			def: string;
			curr: string;
		};
		time: number;
		level: {
			max_value: number;
			rate_up: number;
			rate_down: number;
		};
	};
	questionsMap: { [key: string]: QuestionStr[] };
	bundlesMap: { [key: string]: BundleStr[] };
};
export type QuizeResponse = {
	pid: number;
	qCount: number;
	bCount: number;
	userLvls: UserLvl[];
	quizCats: QuizCat[];
	usedCatIds: number[];
};
export type UserLvl = {
	users_ID: number;
	category_id: number;
	is_700: 1 | 0;
	value: number;
};

export type QIndex = {
	categoryI: number;
	questionsI: number;
	questions700I: number;
	bundlesI: number;
	bundles700I: number;
};

export type ReactPressVars = {
	user: {
		ID: number;
		allcaps: {
			switch_themes: boolean;
			edit_themes: boolean;
			activate_plugins: boolean;
			edit_plugins: boolean;
			edit_users: boolean;
			edit_files: boolean;
			manage_options: boolean;
			moderate_comments: boolean;
			manage_categories: boolean;
			manage_links: boolean;
			upload_files: boolean;
			import: boolean;
			unfiltered_html: boolean;
			edit_posts: boolean;
			edit_others_posts: boolean;
			edit_published_posts: boolean;
			publish_posts: boolean;
			edit_pages: boolean;
			read: boolean;
			level_10: boolean;
			level_9: boolean;
			level_8: boolean;
			level_7: boolean;
			level_6: boolean;
			level_5: boolean;
			level_4: boolean;
			level_3: boolean;
			level_2: boolean;
			level_1: boolean;
			level_0: boolean;
			edit_others_pages: boolean;
			edit_published_pages: boolean;
			publish_pages: boolean;
			delete_pages: boolean;
			delete_others_pages: boolean;
			delete_published_pages: boolean;
			delete_posts: boolean;
			delete_others_posts: boolean;
			delete_published_posts: boolean;
			delete_private_posts: boolean;
			edit_private_posts: boolean;
			read_private_posts: boolean;
			delete_private_pages: boolean;
			edit_private_pages: boolean;
			read_private_pages: boolean;
			delete_users: boolean;
			create_users: boolean;
			unfiltered_upload: boolean;
			edit_dashboard: boolean;
			update_plugins: boolean;
			delete_plugins: boolean;
			install_plugins: boolean;
			update_themes: boolean;
			install_themes: boolean;
			update_core: boolean;
			list_users: boolean;
			remove_users: boolean;
			promote_users: boolean;
			edit_theme_options: boolean;
			delete_themes: boolean;
			export: boolean;
			administrator: boolean;
		};
		caps: { [key: string]: boolean };
		roles: string[];
	};
	usermeta:
		| {
				nickname: string[];
				first_name: string[];
				last_name: string[];
				rich_editing: StrBool[];
				syntax_highlighting: StrBool[];
				wp_capabilities: [string];
				wp_user_level: string[];
				dismissed_wp_pointers: string[];
				show_welcome_panel: string[];
				session_tokens: string[];
		  }
		| false;
	api: {
		nonce: string;
		rest_url: string;
	};
};
export type QuizPointers = {
	currLvl: number;
	qIndexes: number[];
	lengths: number[];
};
export type QuizPointersState = {
	currIndex: number;
	pointers: QuizPointers[];
};

export enum Q_STATUS {
	'RIGHT' = 0,
	'WRONG' = 1,
	'TIMED' = 2,
}
export enum Q_STATUS_STR {
	'RIGHT' = '0',
	'WRONG' = '1',
	'TIMED' = '2',
}

// export type QPointers = {
//     qIndexes: number[];
//     lengths: number[];
// };
export type QMap = {
	pointers: number[];
	lengths: number[];
	questionsLeft: number;
};

export type QuizState = {
	lvl: number;
	qMap: QMap;
};

export type DomainStr = {
	id: string;
	name: string;
	categories: CategoryStr[];
};
export type CategoryStr = {
	id: string;
	name: string;
	domain_id: string;
	level: Level;
	subcategories?: Subcategory[];
	subjects?: Subject[];
};
export type SubjectStr = {
	id: string;
	name: string;
	subcategory_id?: string;
	category_id: string;
	domain_id: string;
};

export type MydataProduct = {
	id: number;
	name: string;
	domains: { [key: string]: DomainStr };
	questions: MydataQuestion[];
};
export type SelectOpt = {
	label: string;
	value: string;
};
export type MydataOpts = {
	products: SelectOpt[];
	domains: { [key: string]: SelectOpt[] };
	categories: { [key: string]: { [key: string]: SelectOpt[] } };
	subjects: { [key: string]: { [key: string]: SelectOpt[] } };
	levels: { [key: string]: { [key: string]: SelectOpt[] } };
};
export type MydataResponse = {
	questions: {
		[key: string]: MydataQuestion[];
	};
	bundles: { [key: string]: BundleStr[] };
	opts: MydataOpts;
	cats: {
		domains: DomainStr[];
		categories: CategoryStr[];
		subjects: SubjectStr[];
	};
};

export type MydataQuestion = {
	id: string;
	makat: null | string;
	content: string;
	solution: string;
	level: null | string;
	level_700: null | string;
	is_demo: null | '1';
	is_700: null | '1';
	is_published: null | '1';
	ans_layout: AnsLayout;
	index_in_bundle: null | string;
	domain_id: string;
	category_id: string;
	subcategory_id: null | string;
	subject_id: null | string;
	bundle_id: null | string;
	posts_id: string;
	status: Q_STATUS_STR;
	selected_ans_id?: AnswerIDStr | null;
	access_date: string; //'2022-10-23 22:52:20'
	solving_time: string;
	answers: AnswerArrStr;
};
